// EstimateSection.js
import React from "react";
import { Link } from "react-router-dom";
import side_image2 from "../../Assets/cc-middle.jpg";
import "./EstimateSection.css";

const EstimateSection = () => (
  <section className="estimate-premium">
    {/* Animated gradient orbs */}
    <div className="estimate-orb estimate-orb-1"></div>
    <div className="estimate-orb estimate-orb-2"></div>
    <div className="estimate-orb estimate-orb-3"></div>

    <div className="estimate-container">
      {/* Left Column - Image with Stats Overlay */}
      <div className="estimate-visual">
        <div className="estimate-image-card">
          <div className="estimate-image-frame">
            <img 
              src={side_image2} 
              alt="Premium fireworks collection" 
              className="estimate-main-image"
            />
            <div className="estimate-image-shine"></div>
          </div>
          
          {/* Floating stat badges */}
          {/* <div className="estimate-stat estimate-stat-1">
            <div className="estimate-stat-icon">⭐</div>
            <div className="estimate-stat-content">
              <span className="estimate-stat-value">4.98</span>
              <span className="estimate-stat-label">Customer Rating</span>
            </div>
          </div> */}
          
          {/* <div className="estimate-stat estimate-stat-2">
            <div className="estimate-stat-icon">🎯</div>
            <div className="estimate-stat-content">
              <span className="estimate-stat-value">20K+</span>
              <span className="estimate-stat-label">Happy Clients</span>
            </div>
          </div> */}
          
          <div className="estimate-stat estimate-stat-3">
            <div className="estimate-stat-icon">⚡</div>
            <div className="estimate-stat-content">
              <span className="estimate-stat-value">24/7</span>
              <span className="estimate-stat-label">Support</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column - Content */}
      <div className="estimate-content">
        {/* Trust Badge */}
        {/* <div className="estimate-trust-badge">
          <div className="estimate-trust-dot"></div>
          <span>Trusted by 10,000+ businesses</span>
        </div> */}

        {/* Main Heading */}
        <h1 className="estimate-heading">
          Get Your Custom
          <span className="estimate-heading-accent"> Crackers Estimate</span>
          <span className="estimate-heading-light"> In Minutes</span>
        </h1>

        {/* Description */}
        <p className="estimate-description">
          Plan your celebration budget with precision. Our AI-powered estimator 
          provides instant, transparent pricing for weddings, Diwali, and corporate events.
        </p>

        {/* Features Grid */}
        <div className="estimate-features-grid">
          <div className="estimate-feature-item">
            <div className="estimate-feature-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 12H18L15 21L9 3L6 12H2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>
              <h4>Instant Quote</h4>
              <p>Real-time pricing</p>
            </div>
          </div>

          <div className="estimate-feature-item">
            <div className="estimate-feature-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 6v6l4 2"/>
              </svg>
            </div>
            <div>
              <h4>Fast Delivery</h4>
              <p>Pan-India shipping</p>
            </div>
          </div>

          <div className="estimate-feature-item">
            <div className="estimate-feature-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
              </svg>
            </div>
            <div>
              <h4>Best Price</h4>
              <p>Price match guarantee</p>
            </div>
          </div>

          <div className="estimate-feature-item">
            <div className="estimate-feature-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <div>
              <h4>Secure Payment</h4>
              <p>100% safe checkout</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="estimate-cta-wrapper">
          <Link to="/quick" className="estimate-cta-primary">
            <span>Get Free Estimate</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
          
          <div className="estimate-cta-secondary">
            <div className="estimate-avatar-group">
              <div className="estimate-avatar estimate-avatar-1">JD</div>
              <div className="estimate-avatar estimate-avatar-2">MK</div>
              <div className="estimate-avatar estimate-avatar-3">RS</div>
              <div className="estimate-avatar estimate-avatar-more">+</div>
            </div>
            <div className="estimate-reviews">
              <div className="estimate-stars">
                ★★★★★
              </div>
              <span>25+ reviews</span>
            </div>
          </div>
        </div>

        {/* Trust indicators */}
        <div className="estimate-trust-footer">
          <div className="estimate-trust-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 16v-4M12 8h.01"/>
            </svg>
            <span>No hidden fees</span>
          </div>
          <div className="estimate-trust-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            <span>Free consultation</span>
          </div>
          <div className="estimate-trust-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <span>Flexible payment</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default EstimateSection;